/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespRefineMenuSelector_viewer$ref = any;
type SbRespSearchResultContainer_viewer$ref = any;
export type SbRespMainContent_viewer$ref = any;
export type SbRespMainContent_viewer = {
    readonly isContentModuleEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespRefineMenuSelector_viewer$ref & SbRespSearchResultContainer_viewer$ref;
    readonly " $refType": SbRespMainContent_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isContentModuleEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "BROWSE_CONTENT_MODULES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'e7f7e83901edb632ca0eb7377fef5525';
export default node;
